<template>
  <div class="card">
    <div class="card-header">
      <i class="icon-refresh"></i> Filtrer les {{ type }}s
    </div>

    <div class="card-block">
      <div class="row">
        <div class="form-group col-sm-4">
          <label>Date de début</label>
          <datepicker
            v-model="filters.begin"
            format="dd.MM.yyyy"
            language="fr"
            input-class="form-control"
          ></datepicker>
        </div>
        <div class="form-group col-sm-4">
          <label>Date de fin</label>
          <datepicker
            v-model="filters.end"
            format="dd.MM.yyyy"
            language="fr"
            input-class="form-control"
          ></datepicker>
        </div>
        <div class="form-group col-sm-4">
          <label>Statut</label>
          <multiselect
            v-model="filters.status"
            :options="availableStatuses"
            :multiple="true"
            :clear-on-select="false"
            :preserve-search="true"
            label="label"
            track-by="value"
            placeholder="Choisir"
            class="custom-multiselect"
          >
          </multiselect>
        </div>
      </div>
    </div>

    <div class="card-footer d-flex justify-content-between">
      <button
        type="button"
        class="btn btn-sm btn-secondary"
        @click="applyFilters()"
      >
        <i class="icon-eye"></i>&nbsp; Visualiser
      </button>
    </div>
  </div>
</template>

<script>
import Datepicker from "vuejs-datepicker";
import Multiselect from "vue-multiselect";
import { mapGetters } from "vuex";

export default {
  components: {
    Datepicker,
    Multiselect,
  },

  props: {
    type: {
      type: String,
      required: true,
    },
    initialFilter: {
      type: Object,
      default: () => ({}),
    },
  },

  data() {
    return {
      filters: {
        begin: null,
        end: null,
        status: [],
      },
    };
  },

  computed: {
    ...mapGetters({
      clientStatus: "getClientStatus",
      prospectStatus: "getProspectStatus",
    }),

    availableStatuses() {
      if (this.type === "prospect") {
        return this.prospectStatus;
      } else {
        return this.clientStatus;
      }
    },
  },

  methods: {
    applyFilters() {
      const filters = {
        ...this.filters,
        begin: this.filters.begin,
        end: this.filters.end,
        status: this.filters.status.map((item) => item.value || item),
      };

      this.$emit("applyFilters", filters);
    },
  },

  mounted() {
    this.filters = { ...this.filters, ...this.initialFilter };
  },

  watch: {
    initialFilter: {
      handler(newVal) {
        this.filters = { ...this.filters, ...newVal };
      },
      deep: true,
    },
  },
};
</script>
